export default "__VITE_ASSET__B$Pht1Ak__"